const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

async function request(endpoint, options = {}, retries = 2) {
  const url = `${API_BASE_URL}${endpoint}`;

  const authHeaders = {};
  try {
    const savedUser = sessionStorage.getItem('user');
    if (savedUser) {
      const userObj = JSON.parse(savedUser);
      if (userObj && userObj.token) {
        authHeaders['Authorization'] = `Bearer ${userObj.token}`;
      }
    }
  } catch (_) {}

  const config = {
    headers: {
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      'Pragma': 'no-cache',
      'Expires': '0',
      ...authHeaders,
      ...options.headers,
    },
    cache: 'no-store',  
    ...options,
  };

  try {
    const response = await fetch(url, config);

    if (!response.ok) {
      let errorMessage = `HTTP error! status: ${response.status}`;
      let errorData = null;

      try {
        errorData = await response.json();
        if (errorData && errorData.message) {
          errorMessage = errorData.message;
        }
      } catch (e) {
        try {
          const errorText = await response.text();
          if (errorText) {
            errorMessage = errorText;
          }
        } catch (textError) {
        }
      }

      const error = new Error(errorMessage);
      error.status = response.status;
      error.response = {
        data: errorData || { message: errorMessage }
      };
      throw error;
    }

    return response.json();
  } catch (error) {
    // Retry nếu là lỗi network và còn retries
    if (retries > 0 && (error.message === 'Failed to fetch' || error.name === 'TypeError')) {
      console.log(`Retrying request to ${url}, ${retries} attempts remaining...`);
      await new Promise(resolve => setTimeout(resolve, 500)); // Đợi 500ms
      return request(endpoint, options, retries - 1);
    }
    throw error;
  }
}

export const api = {
  get: (endpoint) => request(endpoint, { method: 'GET' }),
  post: (endpoint, data) => request(endpoint, {
    method: 'POST',
    body: JSON.stringify(data)
  }),
  put: (endpoint, data) => request(endpoint, {
    method: 'PUT',
    body: JSON.stringify(data)
  }),
  delete: (endpoint) => request(endpoint, { method: 'DELETE' }),
};

export default api;
